var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-expanded-filters-list.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "category/templates/category-expanded-filters-list.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("genericUrl")) {
var t_4 = t_1.genericUrl;
} else {
cb(new Error("cannot import 'genericUrl'")); return;
}
context.setVariable("genericUrl", t_4);
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "filtersSelected")) {
output += "\n\n\t<ul class=\"c-category-expanded-filters__ul\" aria-live=\"polite\">\n\n\t\t";
frame = frame.push();
var t_7 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"facetOptions")),"selectedFacetsList");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("selectedFacet", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
var t_9;
t_9 = env.getFilter("lower").call(context, env.getFilter("sanitize_attr").call(context, runtime.memberLookup((t_8),"value")));
frame.set("facetValue", t_9, true);
if(frame.topLevel) {
context.setVariable("facetValue", t_9);
}
if(frame.topLevel) {
context.addExport("facetValue", t_9);
}
var t_10;
t_10 = env.getFilter("lower").call(context, env.getFilter("replace").call(context, runtime.memberLookup((t_8),"value"),"/","-"));
frame.set("facetValueMatch", t_10, true);
if(frame.topLevel) {
context.setVariable("facetValueMatch", t_10);
}
if(frame.topLevel) {
context.addExport("facetValueMatch", t_10);
}
var t_11;
t_11 = runtime.memberLookup((t_8),"value");
frame.set("displayName", t_11, true);
if(frame.topLevel) {
context.setVariable("displayName", t_11);
}
if(frame.topLevel) {
context.addExport("displayName", t_11);
}
output += "\n\t\t\t";
var t_12;
t_12 = runtime.memberLookup((t_8),"name");
frame.set("facetName", t_12, true);
if(frame.topLevel) {
context.setVariable("facetName", t_12);
}
if(frame.topLevel) {
context.addExport("facetName", t_12);
}
output += "\n\t\t\t";
var t_13;
t_13 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs")),"browseDisplayOptions")),"colorFacets")),runtime.contextOrFrameLookup(context, frame, "facetValue"));
frame.set("isColor", t_13, true);
if(frame.topLevel) {
context.setVariable("isColor", t_13);
}
if(frame.topLevel) {
context.addExport("isColor", t_13);
}
output += "\n\n\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs")),"browseDisplayOptions")),"colorFacets")) {
output += "\n\n\t\t\t\t";
var t_14;
t_14 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs")),"browseDisplayOptions")),"colorFacets")),runtime.contextOrFrameLookup(context, frame, "facetValueMatch"));
frame.set("colorFacetConfig", t_14, true);
if(frame.topLevel) {
context.setVariable("colorFacetConfig", t_14);
}
if(frame.topLevel) {
context.addExport("colorFacetConfig", t_14);
}
if(runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")) {
output += "\n\n\t\t\t        ";
output += "\n\t\t\t        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"hexCode")) {
output += "\n\n\t\t\t            ";
var t_15;
t_15 = "background: #" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"hexCode");
frame.set("inLineBackground", t_15, true);
if(frame.topLevel) {
context.setVariable("inLineBackground", t_15);
}
if(frame.topLevel) {
context.addExport("inLineBackground", t_15);
}
output += "\n\n\t\t\t        ";
;
}
output += "\n\n\t\t\t        ";
output += "\n\t\t\t        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"swatchUrl")) {
output += "\n\n\t\t\t            ";
var t_16;
t_16 = "background: url(" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"swatchUrl") + "" + ") repeat;background-size: cover;";
frame.set("inLineBackground", t_16, true);
if(frame.topLevel) {
context.setVariable("inLineBackground", t_16);
}
if(frame.topLevel) {
context.addExport("inLineBackground", t_16);
}
output += "\n\n\t\t\t        ";
;
}
output += "\n\n\t\t\t        ";
output += "\n\t\t\t        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"swatchUrl") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"hexCode")) {
output += "\n\n\t\t\t            ";
var t_17;
t_17 = "background: #" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"hexCode") + "" + " url(" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"swatchUrl") + "" + ") repeat;background-size: cover";
frame.set("inLineBackground", t_17, true);
if(frame.topLevel) {
context.setVariable("inLineBackground", t_17);
}
if(frame.topLevel) {
context.addExport("inLineBackground", t_17);
}
output += "\n\n\t\t\t        ";
;
}
output += "\n\n\t\t\t        ";
var t_18;
t_18 = "style=\"" + "" + runtime.contextOrFrameLookup(context, frame, "inLineBackground") + "" + "\"";
frame.set("inLineStyle", t_18, true);
if(frame.topLevel) {
context.setVariable("inLineStyle", t_18);
}
if(frame.topLevel) {
context.addExport("inLineStyle", t_18);
}
output += "\n\n\t\t\t        ";
output += "\n\t\t\t        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"displayName")) {
output += "\n\n\t\t\t            ";
var t_19;
t_19 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "colorFacetConfig")),"displayName");
frame.set("displayName", t_19, true);
if(frame.topLevel) {
context.setVariable("displayName", t_19);
}
if(frame.topLevel) {
context.addExport("displayName", t_19);
}
output += "\n\n\t\t\t        ";
;
}
output += "   \n\n\t\t\t    ";
;
}
output += "        \n\n\t\t\t";
;
}
output += "\n\n\t\t\t<li class=\"c-category-expanded-filters__li\">\n\t\t\t    <a class=\"c-category-expanded-filters__a js-expanded-filter__a\" href=\"#\"\n\t\t\t\t\taria-selected=\"true\"\n\t\t\t\t\taria-label=\"";
output += runtime.suppressValue((lineno = 58, colno = 19, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_selected-filter",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "facetName"),runtime.contextOrFrameLookup(context, frame, "displayName")]})])), env.opts.autoescape);
output += "\"\n\t\t\t\t\tdata-query-string=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_8),"queryString")), env.opts.autoescape);
output += "\"\n\t\t\t\t\tdata-cm-element=\"category_facet_";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "facetName"), env.opts.autoescape);
output += "\"\n\t\t\t\t\tdata-element-name=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "facetName"), env.opts.autoescape);
output += "\" data-qa-horizontal-filter-button>\n\n\t\t\t    \t";
if(runtime.memberLookup((t_8),"value")) {
output += "\n\t\t\t\t    \t";
if(runtime.contextOrFrameLookup(context, frame, "isColor")) {
output += "\n\t\t\t\t    \t\t<span title=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"value"), env.opts.autoescape);
output += "\" class=\"c-category-expanded-filters__color-swatch\" ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "inLineStyle")), env.opts.autoescape);
output += "></span>\n\t\t\t\t    \t\t<span class=\"c-category-expanded-filters__label\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "displayName"), env.opts.autoescape);
output += "</span>\n\t\t\t\t    \t";
;
}
else {
output += "\n\t\t\t\t    \t\t<span class=\"c-category-expanded-filters__label\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "displayName"), env.opts.autoescape);
output += "</span>\n\t\t\t\t    \t";
;
}
output += "\n\t\t\t\t    ";
;
}
output += "\n\t\t\t    </a>\n\t\t\t</li>\n\n\t\t";
;
}
}
frame = frame.pop();
output += "\n\n\t\t<li class=\"c-category-expanded-filters__li\">\n\t\t\t<a class=\"c-category-expanded-filters__a--clear-link js-facets-reset\" data-facets-reset=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"facetOptions")),"reset")),"queryString")), env.opts.autoescape);
output += "\" href=\"";
output += runtime.suppressValue((lineno = 77, colno = 159, runtime.callWrap(t_4, "genericUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"catalogRequestPathname"),runtime.makeKeywordArgs({"excludeContextPath": runtime.contextOrFrameLookup(context, frame, "True")})])), env.opts.autoescape);
output += "\">\n\t        \t";
output += runtime.suppressValue((lineno = 78, colno = 12, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_selected-facets-list-clear-link"])), env.opts.autoescape);
output += "\n\t    \t</a>\n\t\t</li>\n\t</ul>\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-expanded-filters-list.j2"] , dependencies)